import React from 'react';
import { PhoneCall, ClipboardList, Shovel } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: <PhoneCall size={28} data-id="element-131" />,
    title: 'Call or Text Us',
    description: 'Reach out by call, text, or WhatsApp at (619) 249-2966 — we respond fast.'
  }, {
    icon: <ClipboardList size={28} data-id="element-132" />,
    title: 'Get Your Free Estimate',
    description: "We come to your property, assess what's needed, and give you a clear quote. No pressure, no cost."
  }, {
    icon: <Shovel size={28} data-id="element-133" />,
    title: 'We Handle Everything',
    description: 'Once you approve, our team gets to work and transforms your exterior — on schedule, on budget.'
  }];
  return <section className="py-14 bg-lightGray relative overflow-hidden" data-id="element-134">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-135">
        <div className="text-center mb-10" data-id="element-136">
          <span className="text-primary font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-137">
            IT'S THIS SIMPLE
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-darkCharcoal" data-id="element-138">
            Your Perfect Yard in 3 Easy Steps
          </h2>
        </div>

        <div className="relative" data-id="element-139">
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-gray-300 z-0" data-id="element-140"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-141">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex flex-col items-center text-center" data-id="element-142">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-md border-4 border-lightGray mb-4 relative" data-id="element-143">
                  <div className="absolute -top-2 -right-2 bg-primary text-white w-7 h-7 rounded-full flex items-center justify-center font-bold text-xs border-2 border-white" data-id="element-144">
                    {index + 1}
                  </div>
                  <div className="text-primary" data-id="element-145">{step.icon}</div>
                </div>
                <h3 className="text-lg font-bold text-darkCharcoal mb-2" data-id="element-146">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-147">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}